import { PortfolioReviewBucket } from "creso-core/types";

export type HoldingColumnKey =
  | "source"
  | "quartile"
  | "xirr"
  | "invested"
  | "current"
  | "weight"
  | "stcg"
  | "ltcg";

export type ColumnOption<K extends string> = {
  key: K;
  label: string;
  group: "visible" | "general";
  // Figures are right-aligned so their digits and "-" placeholders line up.
  numeric?: boolean;
};

// Fund name and Action are always shown, so they are not toggleable.
export const HOLDING_COLUMNS: ColumnOption<HoldingColumnKey>[] = [
  { key: "source", label: "Source", group: "visible" },
  { key: "quartile", label: "3Y Quartile", group: "visible" },
  { key: "xirr", label: "XIRR", group: "visible", numeric: true },
  { key: "invested", label: "Invested", group: "visible", numeric: true },
  { key: "current", label: "Current", group: "visible", numeric: true },
  { key: "weight", label: "% Holdings", group: "general", numeric: true },
  { key: "stcg", label: "STCG", group: "general", numeric: true },
  { key: "ltcg", label: "LTCG", group: "general", numeric: true },
];

export const DEFAULT_VISIBLE_COLUMNS: HoldingColumnKey[] =
  HOLDING_COLUMNS.filter((c) => c.group === "visible").map((c) => c.key);

export const BUCKET_GROUPS: { bucket: PortfolioReviewBucket; label: string }[] =
  [
    { bucket: "NEW_ADDITION", label: "New additions" },
    { bucket: "SWITCH", label: "Funds to switch" },
    { bucket: "HOLD", label: "Funds to hold" },
    { bucket: "EXIT", label: "Funds to exit" },
  ];

export type SwitchColumnKey =
  | "rank"
  | "aum"
  | "return_1y"
  | "return_3y"
  | "quartile";

export const SWITCH_COLUMNS: ColumnOption<SwitchColumnKey>[] = [
  { key: "rank", label: "Category rank", group: "visible" },
  { key: "aum", label: "AUM", group: "visible" },
  { key: "return_1y", label: "1Y", group: "visible" },
  { key: "return_3y", label: "3Y", group: "visible" },
  { key: "quartile", label: "3Y Quartile", group: "general" },
];

export type PickColumnKey =
  | "rank"
  | "aum"
  | "return_1y"
  | "return_3y"
  | "return_5y";

export const PICK_COLUMNS: ColumnOption<PickColumnKey>[] = [
  { key: "rank", label: "Category rank", group: "visible" },
  { key: "aum", label: "AUM", group: "visible" },
  { key: "return_3y", label: "3Y", group: "visible" },
  { key: "return_1y", label: "1Y", group: "general" },
  { key: "return_5y", label: "5Y", group: "general" },
];
